import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const PreloadIframe = styled.iframe`
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`;

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 16/9;
  background: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

const MainIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #1a1a1a;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
  opacity: ${props => props.$isLoading ? 1 : 0};
  pointer-events: ${props => props.$isLoading ? 'auto' : 'none'};
`;

const YouTubePreloader = ({ videoId, title = "YouTube Video" }) => {
  const [isLoading, setIsLoading] = useState(true);
  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  useEffect(() => {
    // Reset loading state when video ID changes
    setIsLoading(true);

    // Create a hidden iframe to preload the video
    const preloadIframe = document.createElement('iframe');
    preloadIframe.src = `${embedUrl}?autoplay=0`;
    preloadIframe.style.display = 'none';
    document.body.appendChild(preloadIframe);

    // Start a timer to show the video after a minimum loading time
    const minLoadTime = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => {
      clearTimeout(minLoadTime);
      document.body.removeChild(preloadIframe);
    };
  }, [videoId, embedUrl]);

  return (
    <VideoContainer>
      <MainIframe
        src={`${embedUrl}?autoplay=0&rel=0`}
        title={title}
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
      <LoadingOverlay $isLoading={isLoading}>
        Loading...
      </LoadingOverlay>
    </VideoContainer>
  );
};

export default YouTubePreloader;
